import React from "react";
import Image from "react-bootstrap/Image";
import Media from "react-media";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export const CuisineSetupHomeScreen = ({ onClick, handleFormHide }) => {
  return (
    <React.Fragment>
      <div>
        <div className="f24_700_HelveticaNeue pb-4">Cuisine Setup</div>
        <div className="f14-700 pb-4">
          Key Points about you that Customers Must Be Aware Of:{" "}
        </div>
        <div style={{ height: "52vh", maxWidth: 500 }}>
          <p className="f12-400">
            It is important to mention the food categories you offer so that the
            user can order preferred food accordingly. The food categories that
            you enter will also help the user find their preferred food that you
            put in while uploading the menu.
          </p>
          <br />
          <p className="f12-400">
            Specify if you serve alcohol at your establishment, as well as the
            type of alcohol you offer, so that customers are aware of their
            options and may quickly obtain their chosen beverage.
          </p>
          <br />
          <p className="f12-400">
            If you allow personalization in your dishes you need to enable a
            toggle here and later fill the information in the menu setup on item
            level.
          </p>
          <br />
          <p className="f12-400">
            You can enable the toggle here and then add the ingredients used in
            your cuisines at the item level in the menu configuration so that
            consumers can get accurate allergy information and avoid harming
            their health by eating something they're allergic to.
          </p>
        </div>
        {/* <div className="col-12 p-0 cuisine-setup-home-div">
          <h4>Cuisine Setup</h4>
          <Image
            src={require("../../../../assets/images/onboarding/cusinesetup.png")}
            alt="Cuisine Setup"
            title="Cuisine Setup"
            fluid
          />
        </div> */}
        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <Media query="(min-width: 992px)">
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link="/healthsenitation"
            />
          </Media>
          <Media query="(max-width: 991px)">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              buttonType="button"
              onClick={handleFormHide}
            />
          </Media>
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onClick}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
